export const DEFAULT_GABLE_ROOF_VENT_WIDTH = 50;
export const FASCIA_THICKNESS = 1.5;
export const FASCIA_TOP_TRIM_THICKNESS = 0.75;
export const FASCIA_TOP_TRIM_SIZE = 2;
export const GABLE_ROOF_VENT_THICKNESS = 1.5;
export const GABLE_TRIM_OFFSET_Z = -0.1;
export const RAFTER_THICKNESS = 1.5;
